import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../../feature'
import type { Manager } from '../manager'

export const deleteNodeFromCytoscape = store.effects.create(
  (feature: Feature, manager: Manager) =>
    feature.actions.deleteNode.observe().pipe(
      rxjs.map(({ data: { id, orgChartId } }) => {
        const cy = manager.getInstance({ orgChartId })
        if (!id || !cy) {
          return
        }
        const nodeToRemove = cy.getElementById(id)
        nodeToRemove.connectedEdges().remove()
        nodeToRemove.remove()
        manager.resetLayout({ orgChartId })
      }),
      rxjs.ignoreElements(),
    ),
)
